import { ReactComponent as ButtonsIcon } from "./buttons.svg";
import { ReactComponent as CardsIcon } from "./cards.svg";
import { ReactComponent as ChartsIcon } from "./charts.svg";
import { ReactComponent as FormsIcon } from "./forms.svg";
import { ReactComponent as HomeIcon } from "./home.svg";
import { ReactComponent as ModalsIcon } from "./modals.svg";
import { ReactComponent as PagesIcon } from "./pages.svg";
import { ReactComponent as TablesIcon } from "./tables.svg";
import { ReactComponent as HeartIcon } from "./heart.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as TrashIcon } from "./trash.svg";
import { ReactComponent as ForbiddenIcon } from "./forbidden.svg";
import { ReactComponent as GithubIcon } from "./github.svg";
import { ReactComponent as TwitterIcon } from "./twitter.svg";
import { ReactComponent as MailIcon } from "./mail.svg";
import { ReactComponent as CartIcon } from "./cart.svg";
import { ReactComponent as ChatIcon } from "./chat.svg";
import { ReactComponent as MoneyIcon } from "./money.svg";
import { ReactComponent as PeopleIcon } from "./people.svg";
import { ReactComponent as SearchIcon } from "./search.svg";
import { ReactComponent as MoonIcon } from "./moon.svg";
import { ReactComponent as SunIcon } from "./sun.svg";
import { ReactComponent as BellIcon } from "./bell.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as DropdownIcon } from "./dropdown.svg";
import { ReactComponent as OutlinePersonIcon } from "./outlinePerson.svg";
import { ReactComponent as OutlineCogIcon } from "./outlineCog.svg";
import { ReactComponent as OutlineLogoutIcon } from "./outlineLogout.svg";
import React from "react";

export const DownloadIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const UploadIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusCircleIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
      clipRule="evenodd"
    />
  </svg>
);

export const CheckCircleIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
);

export const OutlinedThemeIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      d="M3 3a1 1 0 000 2h14a1 1 0 100-2H3zM3 7a1 1 0 000 2h9a1 1 0 100-2H3zM3 11a1 1 0 100 2h9a1 1 0 100-2H3zM3 15a1 1 0 100 2h5a1 1 0 100-2H3z"
      clipRule="evenodd"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const HistoryIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
      clipRule="evenodd"
    />
  </svg>
);

export const DocumentTextIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
      clipRule="evenodd"
    />
  </svg>
);

export const OfficeBuildingIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClipboardListIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
    <path
      fillRule="evenodd"
      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const UserIcon = ({ className, ...props }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
      clipRule="evenodd"
    />
  </svg>
);

export {
  ButtonsIcon,
  CardsIcon,
  ChartsIcon,
  FormsIcon,
  HomeIcon,
  ModalsIcon,
  PagesIcon,
  TablesIcon,
  HeartIcon,
  EditIcon,
  TrashIcon,
  ForbiddenIcon,
  GithubIcon,
  TwitterIcon,
  MailIcon,
  CartIcon,
  ChatIcon,
  MoneyIcon,
  PeopleIcon,
  SearchIcon,
  MoonIcon,
  SunIcon,
  BellIcon,
  MenuIcon,
  DropdownIcon,
  OutlinePersonIcon,
  OutlineCogIcon,
  OutlineLogoutIcon,
};